import axios from "axios";
import { createContext, useState } from "react";

export const CartContext = createContext();

const CartContextProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0)

  const headers = {
    token: localStorage.getItem("userToken"),
  };
  const addToCart = async (productId) => {
    try {
      const resopnse = await axios.post(
        `https://ecommerce.routemisr.com/api/v1/cart`,
        { productId },
        {
          headers
        }
      );
      return resopnse;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      }
      throw error.toString();
    }
  };

  const getLoggedInUserCart = async () => {
    try {
      const response = await axios.get('https://ecommerce.routemisr.com/api/v1/cart',
        {
          headers
        })
      return response.data;
    } catch (error) {
      throw error.response.data.message
    }
  }

  const deleteProductFromCart = async (productId) => {
    try {
      const response = await axios.delete(`https://ecommerce.routemisr.com/api/v1/cart/${productId}`,
        {
          headers
        })
      return response.data;
    } catch (error) {
      throw error.response.data.message
    }
  }
  const updateProductCountInCart = async (productId, count) => {
    try {
      const response = await axios.put(`https://ecommerce.routemisr.com/api/v1/cart/${productId}`, { count },
        {
          headers
        })
      return response.data;
    } catch (error) {
      throw error.response.data.message
    }

  }

  const emptyCart = async () => {
    try {
      const response = await axios.delete(`https://ecommerce.routemisr.com/api/v1/cart`,
        {
          headers
        })
      return response.data;
    } catch (error) {
      throw error.response.data.message
    }
  }

  const payment = async (id, data) => {
    try {
      const response = await axios.post(`https://ecommerce.routemisr.com/api/v1/orders/checkout-session/${id}?url=http://localhost:3000`, data,
        {
          headers
        })
      return response.data;
    } catch (error) {
      throw error.response.data.message
    }
  }


  return (
    <CartContext.Provider value={{ addToCart, getLoggedInUserCart, deleteProductFromCart, updateProductCountInCart, emptyCart, payment, cartCount, setCartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartContextProvider;
